import {
  route,
} from '@app/Routing/helpers'
import { accessPermission } from '@access/permissions'

import {
  QUICK_START_BASE,
} from '@app/Seller/QuickStart/accessTokens'

const QuickStartView = () => import('@app/Seller/QuickStart/View')

const BASE = 'quick_start/'

export const QUICK_START_PREFIX = 'quick_start:'
const p = name => QUICK_START_PREFIX + name

export const QUICK_START_BASE_NAME = p('base')

export function createRoutes(options) {
  return [
    // route(BASE, QuickStartView, QUICK_START_BASE_NAME, {
    //   meta: accessPermission(QUICK_START_BASE, options),
    // }),
    route(BASE, QuickStartView, QUICK_START_BASE_NAME, {
      meta: {
        ...accessPermission(QUICK_START_BASE, options),
        clearview: true,
      },
    }),
  ]
}
